import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { AddPOMutation, GetAllPOQuery } from 'shared/services/po_service/POService';
import { AddSOMutation } from 'shared/services/so_service/SOService';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import Select from 'react-select';
import InnerSoTable from './InnerSoTable';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { toastMessage } from 'shared/components/toast/Toast';
import SaleOrderSuplierModal from 'shared/modal/sale_order_supplier/SaleOrderSupplier';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';
import { GetSkuByWarehouseQuery } from 'shared/services/inventory_service/InventoryService';


export default function SaleOrderModal() {
    const { mutate: addSOMutation, isLoading: SOLoading, isSuccess: ProductIsSuccess } = AddSOMutation();
    const navigate = useNavigate();
    const { data: PoList } = GetAllPOQuery();
    const { data: listWareHouse } = GetAllWarehouse();


    const { theme: { theme } } = useSelector((state) => state.root);

    const [PoListing, setPoListing] = useState([]);
    const [modalShow, setShowModal] = useState(false);
    const [supplierVal, setSupplierVal] = useState('');
    const [wareHouses, setWareHouses] = useState([]);
    const [wareHouseValue, setWareHouseValue] = useState(null);

    const { data: skuData } = GetSkuByWarehouseQuery(wareHouseValue?.value);


    // SKU Options taiyar karna dropdown ke liye based on fetched skuData
    const skuOptions = skuData?.map(item => ({
        label: `${item?.sku} (Stock: ${item?.quantity}, Price: ${item?.price || 0})`,
        value: item?.sku,
        fullData: item
    })) || [];

    useEffect(() => {
        if (listWareHouse) {
            const options = listWareHouse.map(w => ({
                label: w?.code,
                value: w?._id,
            }));
            setWareHouses(options);
        }
    }, [listWareHouse]);

    const handleUpdateQuantity = (index, newQty) => {
        const updatedList = [...PoListing];
        if (updatedList[index]) {
            const quantity = Number(newQty);
            const max = Number(updatedList[index].maxQuantity);

            if (quantity > max) {
                toastMessage('error', `Inventory only has ${max} units available.`);
                return;
            }

            updatedList[index].quantity = quantity;
            setPoListing(updatedList);
            toastMessage('success', "Quantity updated successfully");
        }
    };

    // Jab SKU select ho to direct list mein add ho jaye
    const handleSkuSelect = (selected) => {
        const data = selected?.fullData;
        if (!data) return;

        // Duplicate check
        const isDuplicate = PoListing.some(item => item.sku === data.sku);
        if (isDuplicate) {
            toastMessage('warning', "This SKU is already in the list");
            return;
        }

        const newItem = {
            sku: data.sku,
            product: data.product,
            brand: data.brand,
            competebleBrand: data.compatiableBrand, // mapping with your schema
            product_category: data.product_category,
            sub_category: data.sub_category,
            quantity: data.quantity || 1, // Default to actual quantity (stock)
            price: data.price || 0,
            color: data.color || "N/A",
            raw_images: data.raw_images || [],
            product_category_name: data.product_category?.name,
            maxQuantity: data.quantity // Track available stock for validation
        };

        setPoListing(prev => [...prev, newItem]);
        toastMessage('success', `SKU ${data.sku} added`);
    };

    const handleDeletePoItem = (indexToDelete) => {
        setPoListing(prev => prev.filter((_, index) => index !== indexToDelete));
    };

    const SubmmitPo = async (shippingObj) => {
        if (PoListing.length === 0) {
            toastMessage('error', "Please add at least one item");
            return;
        }

        let obj = {
            order: PoListing.map((item) => ({
                warehouse: wareHouseValue?.value,
                quantity: item.quantity,
                sku: item.sku,
                price: item.price
            })),
            shipping: shippingObj.shipping,
        };

        addSOMutation(obj);
    };

    useEffect(() => {
        if (ProductIsSuccess) {
            navigate(routeConstant.admin.so.list.path);
        }
    }, [ProductIsSuccess, navigate]);

    const isDark = theme?.toLowerCase() === 'dark';

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: '8px',
            border: state.isFocused ? '1px solid #4a86f7' : '1px solid #c9d1e1',
            boxShadow: state.isFocused ? '0 0 0 1px #4a86f7' : 'none',
            '&:hover': {
                border: '1px solid #4a86f7',
            },
            padding: '2px 4px',
            minHeight: '45px',
            backgroundColor: isDark ? '#262c48' : '#fff',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#a8a8a8',
            fontSize: '14px',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDark ? '#fff' : '#000',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDark ? '#262c48' : '#fff',
            borderRadius: '8px',
            overflow: 'hidden',
            zIndex: 100,
            border: isDark ? '1px solid #353f5f' : '1px solid #c9d1e1',
            boxShadow: '0 4px 11px rgba(0, 0, 0, 0.15)',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#4a86f7'
                : state.isFocused
                    ? (isDark ? '#353f5f' : '#e2ecff')
                    : 'transparent',
            color: state.isSelected ? '#fff' : (isDark ? '#fff' : '#000'),
            cursor: 'pointer',
            padding: '10px 15px',
            '&:active': {
                backgroundColor: '#4a86f7',
            },
        }),
        input: (provided) => ({
            ...provided,
            color: isDark ? '#fff' : '#000',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <div className={styles.SelectionRow}>
                        <div className={styles.SelectContainer}>
                            <label className={styles.InputLabel}>Warehouse</label>
                            <Select
                                options={wareHouses}
                                styles={customSelectStyles}
                                isSearchable
                                isClearable
                                placeholder="Select Warehouse"
                                menuPortalTarget={document.body}
                                onChange={(selected) => {
                                    setWareHouseValue(selected);
                                }}
                                value={wareHouseValue}
                            />
                        </div>
                        <div className={styles.SelectContainer}>
                            <label className={styles.InputLabel}>Search SKU</label>
                            <Select
                                options={skuOptions}
                                styles={customSelectStyles}
                                isSearchable
                                placeholder="Search SKU to Add"
                                menuPortalTarget={document.body}
                                onChange={handleSkuSelect}
                                value={null}
                                isDisabled={!wareHouseValue}
                            />
                        </div>
                    </div>
                </div>

                <div className={classNames(styles.Body, "mt-4")}>
                    {/* Table showing added items */}
                    <InnerSoTable
                        // 2. Yahan PoListing pass karein kyunke aapne items isme add kiye hain
                        PoList={PoListing}
                        handleDelete={handleDeletePoItem}
                        handleUpdateQuantity={handleUpdateQuantity}
                    />

                    {PoListing.length > 0 && (
                        <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-end mt-3')}>
                            <CustomButton
                                text={'Continue'}
                                containerStyle={styles.SubmitBtn}
                                submitHandle={() => {
                                    if (isRestrictActions(screenEnum.po, screenActionEnum.create)) {
                                        setShowModal(true);
                                    }
                                }}
                            />
                        </div>
                    )}
                </div>

                <SaleOrderSuplierModal
                    show={modalShow}
                    handleClose={() => setShowModal(false)}
                    SubmmitPo={SubmmitPo}
                    setSupplierVal={setSupplierVal}
                />
            </div>
            {SOLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}